export default "__VITE_ASSET__vziIz$tf__"